import { render } from "./orderDetailsTopSection.vue?vue&type=template&id=70ab4c68"
import script from "./orderDetailsTopSection.vue?vue&type=script&lang=js"
export * from "./orderDetailsTopSection.vue?vue&type=script&lang=js"

import "./orderDetailsTopSection.vue?vue&type=style&index=0&id=70ab4c68&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__